import { render, staticRenderFns } from "./beta.vue?vue&type=template&id=fbd07a08&"
import script from "./beta.vue?vue&type=script&lang=js&"
export * from "./beta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports